/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionConfig } from './CompetitionConfig';
import {
    CompetitionConfigFromJSON,
    CompetitionConfigFromJSONTyped,
    CompetitionConfigToJSON,
    CompetitionConfigToJSONTyped,
} from './CompetitionConfig';
import type { ExternalEventAllowlistEntry } from './ExternalEventAllowlistEntry';
import {
    ExternalEventAllowlistEntryFromJSON,
    ExternalEventAllowlistEntryFromJSONTyped,
    ExternalEventAllowlistEntryToJSON,
    ExternalEventAllowlistEntryToJSONTyped,
} from './ExternalEventAllowlistEntry';
import type { OWGameSteamMatch } from './OWGameSteamMatch';
import {
    OWGameSteamMatchFromJSON,
    OWGameSteamMatchFromJSONTyped,
    OWGameSteamMatchToJSON,
    OWGameSteamMatchToJSONTyped,
} from './OWGameSteamMatch';
import type { ArenaGameConfig } from './ArenaGameConfig';
import {
    ArenaGameConfigFromJSON,
    ArenaGameConfigFromJSONTyped,
    ArenaGameConfigToJSON,
    ArenaGameConfigToJSONTyped,
} from './ArenaGameConfig';
import type { OWGameSEO } from './OWGameSEO';
import {
    OWGameSEOFromJSON,
    OWGameSEOFromJSONTyped,
    OWGameSEOToJSON,
    OWGameSEOToJSONTyped,
} from './OWGameSEO';
import type { OWGameSteamData } from './OWGameSteamData';
import {
    OWGameSteamDataFromJSON,
    OWGameSteamDataFromJSONTyped,
    OWGameSteamDataToJSON,
    OWGameSteamDataToJSONTyped,
} from './OWGameSteamData';
import type { SurfaceGameConfig } from './SurfaceGameConfig';
import {
    SurfaceGameConfigFromJSON,
    SurfaceGameConfigFromJSONTyped,
    SurfaceGameConfigToJSON,
    SurfaceGameConfigToJSONTyped,
} from './SurfaceGameConfig';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';

/**
 * Public-facing OWGame projection — base OWGame plus response-only
 * extension fields (CDN-resolved image URLs, live Steam data,
 * tournament metadata, etc.). The openapi-generator handles this
 * allOf-with-inline-extensions pattern by generating an
 * `interface OWGameResponse extends OWGame` plus a side companion
 * `OWGameResponseAllOf`. Verified empirically with this repo's
 * generator — the resulting client model carries every OWGame
 * field plus the extensions below.
 * 
 * @export
 * @interface OWGameResponse
 */
export interface OWGameResponse {
    /**
     * The Overwolf ID of the game
     * @type {string}
     * @memberof OWGameResponse
     */
    gameId: string;
    /**
     * Discord detectable-games application id — the ID join key for Discord presence (console play).
     * @type {string}
     * @memberof OWGameResponse
     */
    discordApplicationId?: string;
    /**
     * The title of the game
     * @type {string}
     * @memberof OWGameResponse
     */
    name: string;
    /**
     * The description of the game.
     * @type {string}
     * @memberof OWGameResponse
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    events: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    devourGameLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    bannerImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    landingImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    landingImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    thumbnailImage?: string;
    /**
     * The image to show in the time reward breakdown
     * @type {string}
     * @memberof OWGameResponse
     */
    timeRewardImage?: string;
    /**
     * The flag to check if the game has event support by Overwolf
     * @type {boolean}
     * @memberof OWGameResponse
     */
    isEventSupported: boolean;
    /**
     * Sources this game is expected to produce GEP events from. Empty array + isEventSupported=true means monitor all sources. Used by Game Tracking Health monitoring to know which source/game pairs to alert on.
     * @type {Array<DataSource>}
     * @memberof OWGameResponse
     */
    expectedSources?: Array<DataSource>;
    /**
     * When set, suppresses RED alerts for this game (e.g. acknowledged Overwolf-side regression). Cron still writes snapshots.
     * @type {string}
     * @memberof OWGameResponse
     */
    trackingHealthSuppressionReason?: string;
    /**
     * Optional auto-clear timestamp; alerting resumes after this Unix-ms.
     * @type {number}
     * @memberof OWGameResponse
     */
    trackingHealthSuppressedUntil?: number;
    /**
     * The flag to check if the game is supported by DevourGO
     * @type {boolean}
     * @memberof OWGameResponse
     */
    isEventSupportReady?: boolean;
    /**
     * Whether competitions (tournaments, challenges, ladders) are supported for this game
     * @type {boolean}
     * @memberof OWGameResponse
     */
    competitionSupported?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGameResponse
     */
    hasUserStats?: boolean;
    /**
     * Steam App ID for the game
     * @type {number}
     * @memberof OWGameResponse
     */
    steamAppId?: number;
    /**
     * SEO-friendly URL slug
     * @type {string}
     * @memberof OWGameResponse
     */
    slug?: string;
    /**
     * Whether time tracking is enabled for this game
     * @type {boolean}
     * @memberof OWGameResponse
     */
    timeTrackedGame?: boolean;
    /**
     * Whether this entry is a platform launcher (Battle.net, Epic, Steam, etc.). Used to suppress launcher heartbeats when a non-launcher game is the current session.
     * @type {boolean}
     * @memberof OWGameResponse
     */
    isLauncher?: boolean;
    /**
     * 
     * @type {OWGameSEO}
     * @memberof OWGameResponse
     */
    seo?: OWGameSEO;
    /**
     * 
     * @type {OWGameSteamMatch}
     * @memberof OWGameResponse
     */
    steamMatch?: OWGameSteamMatch;
    /**
     * 
     * @type {OWGameSteamData}
     * @memberof OWGameResponse
     */
    steamData?: OWGameSteamData;
    /**
     * Custom Devour game categories for carousel grouping
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    devourCategories?: Array<string>;
    /**
     * Whether this game is available in Challenge Arena for user-created challenges
     * @type {boolean}
     * @memberof OWGameResponse
     */
    arenaEnabled?: boolean;
    /**
     * Whether this game has event pipeline integration for automated scoring
     * @type {boolean}
     * @memberof OWGameResponse
     */
    autoScoringCapable?: boolean;
    /**
     * External game identifier used by Blitz integration
     * @type {string}
     * @memberof OWGameResponse
     */
    blitzGameId?: string;
    /**
     * Hex color for competition card branding (e.g.,
     * @type {string}
     * @memberof OWGameResponse
     */
    brandColor?: string;
    /**
     * Hashtags appended to every social post about this game, e.g. ["#LeagueOfLegends", "#LoL"]. Empty means posts about this game carry no tags.
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    socialHashtags?: Array<string>;
    /**
     * Publisher named in "Not affiliated with X." on posts carrying this game's art. Absent omits the line rather than guessing the company.
     * @type {string}
     * @memberof OWGameResponse
     */
    socialDisclaimerEntity?: string;
    /**
     * 
     * @type {ArenaGameConfig}
     * @memberof OWGameResponse
     */
    arenaConfig?: ArenaGameConfig;
    /**
     * Whether Hub activities are enabled for this game
     * @type {boolean}
     * @memberof OWGameResponse
     */
    hubEnabled?: boolean;
    /**
     * 
     * @type {SurfaceGameConfig}
     * @memberof OWGameResponse
     */
    hubConfig?: SurfaceGameConfig;
    /**
     * Master toggle for Overwolf clip capture for this game
     * @type {boolean}
     * @memberof OWGameResponse
     */
    clipEnabled?: boolean;
    /**
     * Windows exe name passed to the Overwolf recorder (e.g. VALORANT-Win64-Shipping.exe)
     * @type {string}
     * @memberof OWGameResponse
     */
    gameProcess?: string;
    /**
     * Twitch game_id values that map to this title. Authoritative join key for "is this creator streaming this game".
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    twitchGameIds?: Array<string>;
    /**
     * Kick category.id values that map to this title.
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased YouTube game names — YouTube exposes no stable per-title game id.
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    youtubeGameNames?: Array<string>;
    /**
     * Lowercased aliases matched against stream title and tag text. Weakest signal, and the only one available before a title has a platform category.
     * @type {Array<string>}
     * @memberof OWGameResponse
     */
    streamTitleAliases?: Array<string>;
    /**
     * Events exposed to self-serve authoring for this game. Empty means the game is not self-serve-ready.
     * @type {Array<ExternalEventAllowlistEntry>}
     * @memberof OWGameResponse
     */
    externalEventAllowlist?: Array<ExternalEventAllowlistEntry>;
    /**
     * 
     * @type {string}
     * @memberof OWGameResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OWGameResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameResponse
     */
    updatedAt: number;
    /**
     * Generated Steam logo URL
     * @type {string}
     * @memberof OWGameResponse
     */
    steamLogoUrl?: string;
    /**
     * When Steam data was last refreshed
     * @type {Date}
     * @memberof OWGameResponse
     */
    steamDataLastRefreshed?: Date;
    /**
     * Steam news data
     * @type {{ [key: string]: any; }}
     * @memberof OWGameResponse
     */
    steamNews?: { [key: string]: any; };
    /**
     * CDN URL for logo asset
     * @type {string}
     * @memberof OWGameResponse
     */
    logoUrl?: string;
    /**
     * CDN URL for icon asset
     * @type {string}
     * @memberof OWGameResponse
     */
    iconUrl?: string;
    /**
     * CDN URL for devour game logo asset
     * @type {string}
     * @memberof OWGameResponse
     */
    devourGameLogoUrl?: string;
    /**
     * CDN URL for hero (banner-scale) image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    heroImageUrl?: string;
    /**
     * CDN URL for thumbnail image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    thumbnailImageUrl?: string;
    /**
     * CDN URL for small banner image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    bannerImageSmallUrl?: string;
    /**
     * CDN URL for large banner image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    bannerImageLargeUrl?: string;
    /**
     * CDN URL for small landing image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    landingImageSmallUrl?: string;
    /**
     * CDN URL for large landing image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    landingImageLargeUrl?: string;
    /**
     * CDN URL for time reward image asset
     * @type {string}
     * @memberof OWGameResponse
     */
    timeRewardImageUrl?: string;
    /**
     * Count of active standalone (public) competitions for this game
     * @type {number}
     * @memberof OWGameResponse
     */
    activeCompetitionCount?: number;
    /**
     * Live Steam concurrent-player count (populated by get_game_by_slug, 5-minute cache)
     * @type {number}
     * @memberof OWGameResponse
     */
    currentPlayers?: number;
    /**
     * 
     * @type {CompetitionConfig}
     * @memberof OWGameResponse
     */
    competitionConfig?: CompetitionConfig;
    /**
     * Short tournament identifier (e.g., "cod", "fortnite")
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentGameCode?: string;
    /**
     * Display order in the tournament game list
     * @type {number}
     * @memberof OWGameResponse
     */
    tournamentGameOrder?: number;
    /**
     * Per-platform tournament enablement (pc / playstation / xbox / switch / mobile)
     * @type {{ [key: string]: any; }}
     * @memberof OWGameResponse
     */
    tournamentPlatforms?: { [key: string]: any; };
    /**
     * Regional content ratings (northAmerica / europe)
     * @type {{ [key: string]: any; }}
     * @memberof OWGameResponse
     */
    tournamentGameRatings?: { [key: string]: any; };
    /**
     * Whether cross-platform tournament play is allowed
     * @type {boolean}
     * @memberof OWGameResponse
     */
    tournamentCrossplayAllowed?: boolean;
    /**
     * Whether this game supports telemetry-driven auto ready-up (Overwolf co-presence). Defaults true; false leaves manual captain ready-up as the only path.
     * @type {boolean}
     * @memberof OWGameResponse
     */
    autoReadyUpCompatible?: boolean;
    /**
     * CDN URL for the tournament featured (300x400 card) image
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentFeaturedImageUrl?: string;
    /**
     * CDN URL for the tournament header (1200x600 banner) image
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentHeaderImageUrl?: string;
    /**
     * Rich-text tournament description (HTML allowed)
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentDescription?: string;
    /**
     * SEO meta title for tournament pages
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentMetaTitle?: string;
    /**
     * SEO meta description for tournament pages
     * @type {string}
     * @memberof OWGameResponse
     */
    tournamentMetaDescription?: string;
}

/**
 * Check if a given object implements the OWGameResponse interface.
 */
export function instanceOfOWGameResponse(value: object): value is OWGameResponse {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('isEventSupported' in value) || value['isEventSupported'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OWGameResponseFromJSON(json: any): OWGameResponse {
    return OWGameResponseFromJSONTyped(json, false);
}

export function OWGameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'discordApplicationId': json['discordApplicationId'] == null ? undefined : json['discordApplicationId'],
        'name': json['name'],
        'description': json['description'],
        'events': json['events'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'devourGameLogo': json['devourGameLogo'] == null ? undefined : json['devourGameLogo'],
        'bannerImageSmall': json['bannerImageSmall'] == null ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': json['bannerImageLarge'] == null ? undefined : json['bannerImageLarge'],
        'landingImageSmall': json['landingImageSmall'] == null ? undefined : json['landingImageSmall'],
        'landingImageLarge': json['landingImageLarge'] == null ? undefined : json['landingImageLarge'],
        'thumbnailImage': json['thumbnailImage'] == null ? undefined : json['thumbnailImage'],
        'timeRewardImage': json['timeRewardImage'] == null ? undefined : json['timeRewardImage'],
        'isEventSupported': json['isEventSupported'],
        'expectedSources': json['expectedSources'] == null ? undefined : ((json['expectedSources'] as Array<any>).map(DataSourceFromJSON)),
        'trackingHealthSuppressionReason': json['trackingHealthSuppressionReason'] == null ? undefined : json['trackingHealthSuppressionReason'],
        'trackingHealthSuppressedUntil': json['trackingHealthSuppressedUntil'] == null ? undefined : json['trackingHealthSuppressedUntil'],
        'isEventSupportReady': json['isEventSupportReady'] == null ? undefined : json['isEventSupportReady'],
        'competitionSupported': json['competitionSupported'] == null ? undefined : json['competitionSupported'],
        'hasUserStats': json['hasUserStats'] == null ? undefined : json['hasUserStats'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'timeTrackedGame': json['timeTrackedGame'] == null ? undefined : json['timeTrackedGame'],
        'isLauncher': json['isLauncher'] == null ? undefined : json['isLauncher'],
        'seo': json['seo'] == null ? undefined : OWGameSEOFromJSON(json['seo']),
        'steamMatch': json['steamMatch'] == null ? undefined : OWGameSteamMatchFromJSON(json['steamMatch']),
        'steamData': json['steamData'] == null ? undefined : OWGameSteamDataFromJSON(json['steamData']),
        'devourCategories': json['devourCategories'] == null ? undefined : json['devourCategories'],
        'arenaEnabled': json['arenaEnabled'] == null ? undefined : json['arenaEnabled'],
        'autoScoringCapable': json['autoScoringCapable'] == null ? undefined : json['autoScoringCapable'],
        'blitzGameId': json['blitzGameId'] == null ? undefined : json['blitzGameId'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'socialHashtags': json['socialHashtags'] == null ? undefined : json['socialHashtags'],
        'socialDisclaimerEntity': json['socialDisclaimerEntity'] == null ? undefined : json['socialDisclaimerEntity'],
        'arenaConfig': json['arenaConfig'] == null ? undefined : ArenaGameConfigFromJSON(json['arenaConfig']),
        'hubEnabled': json['hubEnabled'] == null ? undefined : json['hubEnabled'],
        'hubConfig': json['hubConfig'] == null ? undefined : SurfaceGameConfigFromJSON(json['hubConfig']),
        'clipEnabled': json['clipEnabled'] == null ? undefined : json['clipEnabled'],
        'gameProcess': json['gameProcess'] == null ? undefined : json['gameProcess'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'youtubeGameNames': json['youtubeGameNames'] == null ? undefined : json['youtubeGameNames'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
        'externalEventAllowlist': json['externalEventAllowlist'] == null ? undefined : ((json['externalEventAllowlist'] as Array<any>).map(ExternalEventAllowlistEntryFromJSON)),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'steamLogoUrl': json['steamLogoUrl'] == null ? undefined : json['steamLogoUrl'],
        'steamDataLastRefreshed': json['steamDataLastRefreshed'] == null ? undefined : (new Date(json['steamDataLastRefreshed'])),
        'steamNews': json['steamNews'] == null ? undefined : json['steamNews'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'devourGameLogoUrl': json['devourGameLogoUrl'] == null ? undefined : json['devourGameLogoUrl'],
        'heroImageUrl': json['heroImageUrl'] == null ? undefined : json['heroImageUrl'],
        'thumbnailImageUrl': json['thumbnailImageUrl'] == null ? undefined : json['thumbnailImageUrl'],
        'bannerImageSmallUrl': json['bannerImageSmallUrl'] == null ? undefined : json['bannerImageSmallUrl'],
        'bannerImageLargeUrl': json['bannerImageLargeUrl'] == null ? undefined : json['bannerImageLargeUrl'],
        'landingImageSmallUrl': json['landingImageSmallUrl'] == null ? undefined : json['landingImageSmallUrl'],
        'landingImageLargeUrl': json['landingImageLargeUrl'] == null ? undefined : json['landingImageLargeUrl'],
        'timeRewardImageUrl': json['timeRewardImageUrl'] == null ? undefined : json['timeRewardImageUrl'],
        'activeCompetitionCount': json['activeCompetitionCount'] == null ? undefined : json['activeCompetitionCount'],
        'currentPlayers': json['currentPlayers'] == null ? undefined : json['currentPlayers'],
        'competitionConfig': json['competitionConfig'] == null ? undefined : CompetitionConfigFromJSON(json['competitionConfig']),
        'tournamentGameCode': json['tournamentGameCode'] == null ? undefined : json['tournamentGameCode'],
        'tournamentGameOrder': json['tournamentGameOrder'] == null ? undefined : json['tournamentGameOrder'],
        'tournamentPlatforms': json['tournamentPlatforms'] == null ? undefined : json['tournamentPlatforms'],
        'tournamentGameRatings': json['tournamentGameRatings'] == null ? undefined : json['tournamentGameRatings'],
        'tournamentCrossplayAllowed': json['tournamentCrossplayAllowed'] == null ? undefined : json['tournamentCrossplayAllowed'],
        'autoReadyUpCompatible': json['autoReadyUpCompatible'] == null ? undefined : json['autoReadyUpCompatible'],
        'tournamentFeaturedImageUrl': json['tournamentFeaturedImageUrl'] == null ? undefined : json['tournamentFeaturedImageUrl'],
        'tournamentHeaderImageUrl': json['tournamentHeaderImageUrl'] == null ? undefined : json['tournamentHeaderImageUrl'],
        'tournamentDescription': json['tournamentDescription'] == null ? undefined : json['tournamentDescription'],
        'tournamentMetaTitle': json['tournamentMetaTitle'] == null ? undefined : json['tournamentMetaTitle'],
        'tournamentMetaDescription': json['tournamentMetaDescription'] == null ? undefined : json['tournamentMetaDescription'],
    };
}

export function OWGameResponseToJSON(json: any): OWGameResponse {
    return OWGameResponseToJSONTyped(json, false);
}

export function OWGameResponseToJSONTyped(value?: OWGameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'discordApplicationId': value['discordApplicationId'],
        'name': value['name'],
        'description': value['description'],
        'events': value['events'],
        'logo': value['logo'],
        'icon': value['icon'],
        'devourGameLogo': value['devourGameLogo'],
        'bannerImageSmall': value['bannerImageSmall'],
        'bannerImageLarge': value['bannerImageLarge'],
        'landingImageSmall': value['landingImageSmall'],
        'landingImageLarge': value['landingImageLarge'],
        'thumbnailImage': value['thumbnailImage'],
        'timeRewardImage': value['timeRewardImage'],
        'isEventSupported': value['isEventSupported'],
        'expectedSources': value['expectedSources'] == null ? undefined : ((value['expectedSources'] as Array<any>).map(DataSourceToJSON)),
        'trackingHealthSuppressionReason': value['trackingHealthSuppressionReason'],
        'trackingHealthSuppressedUntil': value['trackingHealthSuppressedUntil'],
        'isEventSupportReady': value['isEventSupportReady'],
        'competitionSupported': value['competitionSupported'],
        'hasUserStats': value['hasUserStats'],
        'steamAppId': value['steamAppId'],
        'slug': value['slug'],
        'timeTrackedGame': value['timeTrackedGame'],
        'isLauncher': value['isLauncher'],
        'seo': OWGameSEOToJSON(value['seo']),
        'steamMatch': OWGameSteamMatchToJSON(value['steamMatch']),
        'steamData': OWGameSteamDataToJSON(value['steamData']),
        'devourCategories': value['devourCategories'],
        'arenaEnabled': value['arenaEnabled'],
        'autoScoringCapable': value['autoScoringCapable'],
        'blitzGameId': value['blitzGameId'],
        'brandColor': value['brandColor'],
        'socialHashtags': value['socialHashtags'],
        'socialDisclaimerEntity': value['socialDisclaimerEntity'],
        'arenaConfig': ArenaGameConfigToJSON(value['arenaConfig']),
        'hubEnabled': value['hubEnabled'],
        'hubConfig': SurfaceGameConfigToJSON(value['hubConfig']),
        'clipEnabled': value['clipEnabled'],
        'gameProcess': value['gameProcess'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'youtubeGameNames': value['youtubeGameNames'],
        'streamTitleAliases': value['streamTitleAliases'],
        'externalEventAllowlist': value['externalEventAllowlist'] == null ? undefined : ((value['externalEventAllowlist'] as Array<any>).map(ExternalEventAllowlistEntryToJSON)),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'steamLogoUrl': value['steamLogoUrl'],
        'steamDataLastRefreshed': value['steamDataLastRefreshed'] == null ? undefined : ((value['steamDataLastRefreshed']).toISOString()),
        'steamNews': value['steamNews'],
        'logoUrl': value['logoUrl'],
        'iconUrl': value['iconUrl'],
        'devourGameLogoUrl': value['devourGameLogoUrl'],
        'heroImageUrl': value['heroImageUrl'],
        'thumbnailImageUrl': value['thumbnailImageUrl'],
        'bannerImageSmallUrl': value['bannerImageSmallUrl'],
        'bannerImageLargeUrl': value['bannerImageLargeUrl'],
        'landingImageSmallUrl': value['landingImageSmallUrl'],
        'landingImageLargeUrl': value['landingImageLargeUrl'],
        'timeRewardImageUrl': value['timeRewardImageUrl'],
        'activeCompetitionCount': value['activeCompetitionCount'],
        'currentPlayers': value['currentPlayers'],
        'competitionConfig': CompetitionConfigToJSON(value['competitionConfig']),
        'tournamentGameCode': value['tournamentGameCode'],
        'tournamentGameOrder': value['tournamentGameOrder'],
        'tournamentPlatforms': value['tournamentPlatforms'],
        'tournamentGameRatings': value['tournamentGameRatings'],
        'tournamentCrossplayAllowed': value['tournamentCrossplayAllowed'],
        'autoReadyUpCompatible': value['autoReadyUpCompatible'],
        'tournamentFeaturedImageUrl': value['tournamentFeaturedImageUrl'],
        'tournamentHeaderImageUrl': value['tournamentHeaderImageUrl'],
        'tournamentDescription': value['tournamentDescription'],
        'tournamentMetaTitle': value['tournamentMetaTitle'],
        'tournamentMetaDescription': value['tournamentMetaDescription'],
    };
}

